
<template>
  <div class="dwp-space-y-2">
    <div class="dwp-relative dwp-rounded-md dwp-shadow-sm dwp-space-y-1">
      <label
        v-if="label"
        class="dwp-block dwp-text-sm dwp-font-medium dwp-leading-5 dwp-text-gray-700"
        :for="id"
      >{{ label }}</label>
      <input
        :id="id"
        ref="input"
        v-bind="$attrs"
        class="dwp-block dwp-appearance-none dwp-bg-white dwp-rounded dwp-border dwp-border-gray-200 dwp-p-3 focus:dwp-outline-none focus:dwp-shadow-outline focus:dwp-border-gray-500 dwp-w-full sm:dwp-text-sm sm:dwp-leading-5 dwp-shadow-none focus:dwp-shadow-none"
        :class="errors.length ? 'dwp-border-red-300 dwp-text-red-900 dwp-placeholder-red-300 focus:dwp-border-red-300 focus:sdwp-hadow-outline-red' : 'dwp-border-gray-300 dwp-text-gray-900 dwp-placeholder-gray-500 focus:dwp-border-gray-300 focus:sdwp-hadow-outline-gray'"
        :type="type"
        :value="value | decode"
        @input="$emit('input', $event.target.value)"
      />
    </div>
    <div v-if="errors.length" class="dwp-rounded-md dwp-bg-red-100 dwp-p-4">
      <div class="dwp-flex">
        <div class="dwp-flex-shrink-0">
          <svg class="dwp-h-5 dwp-w-5 dwp-text-red-400" fill="currentColor" viewBox="0 0 20 20">
            <path
              fill-rule="evenodd"
              d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z"
              clip-rule="evenodd"
            />
          </svg>
        </div>
        <div class="dwp-ml-3">
          <div class="dwp-text-sm dwp-leading-5 dwp-text-red-700 dwp-space-y-1">
            <ul class="dwp-list-none">
              <li v-for="(error, index) in errors" :key="index">{{error}}</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  inheritAttrs: false,
  props: {
    id: {
      type: String,
      default() {
        return `text-input-${this._uid}`;
      }
    },
    type: {
      type: String,
      default: "text"
    },
    value: String,
    label: String,
    errors: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    focus() {
      this.$refs.input.focus();
    },
    select() {
      this.$refs.input.select();
    },
    setSelectionRange(start, end) {
      this.$refs.input.setSelectionRange(start, end);
    }
  }
};
</script>
